// import React, { useState, useEffect } from "react";
// import { Table, Pagination, Input, Button, Toggle } from "rsuite";
// import { fetchCertificates, updateCertificate } from "../../../api/certificateAPI";
// import { placeholderImage, isValidUrl } from "../../invalidImage";
// import ImageModal from "../../imageModal";
// import ModalCertificate from "./addCertificate";
// import ModalUpdateCertificate from "./updateCertificate";
// import { handleDeleteCertificate } from "./deleteCertificateHandler";

// const { Column, HeaderCell, Cell } = Table;

// const CertificateTable = () => {
//   const [data, setData] = useState([]);
//   const [displayData, setDisplayData] = useState([]);
//   const [page, setPage] = useState(1);
//   const [limit, setLimit] = useState(10);
//   const [searchKeyword, setSearchKeyword] = useState("");
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
//   const [selectedCertificate, setSelectedCertificate] = useState(null);

//   const fetchData = async () => {
//     const certificatesData = await fetchCertificates();
//     setData(certificatesData);
//     setDisplayData(certificatesData.slice(0, limit));
//   };

//   useEffect(() => {
//     fetchData();
//   }, []);

//   useEffect(() => {
//     const start = (page - 1) * limit;
//     const end = start + limit;
//     setDisplayData(data.slice(start, end));
//   }, [page, limit, data]);

//   const handleChangePage = (page) => {
//     setPage(page);
//   };

//   const handleChangeLimit = (limit) => {
//     setLimit(limit);
//     setPage(1);
//   };

//   const handleSearch = (value) => {
//     setSearchKeyword(value);
//     if (value) {
//       const filteredData = data.filter((certificate) =>
//         certificate.name.toLowerCase().includes(value.toLowerCase())
//       );
//       setData(filteredData);
//       setPage(1);
//     } else {
//       fetchData();
//     }
//   };

//   const handleAddCertificate = () => {
//     setIsModalOpen(true);
//   };

//   const handleUpdateCertificate = (certificate) => {
//     setSelectedCertificate(certificate);
//     setIsUpdateModalOpen(true);
//   };

//   const handleToggleStatus = async (certificate) => {
//     const updatedStatus = certificate.status === 1 ? 0 : 1;
//     const updatedCertificate = { ...certificate, status: updatedStatus };

//     try {
//       await updateCertificate(certificate.id, updatedCertificate);
//       setData((prevData) =>
//         prevData.map((item) =>
//           item.id === certificate.id ? { ...item, status: updatedStatus } : item
//         )
//       );
//     } catch (error) {
//       console.error("Failed to update status:", error);
//     }
//   };

//   const closeModal = () => {
//     setIsModalOpen(false);
//     setIsUpdateModalOpen(false);
//   };

//   return (
//     <div className="flex-1 h-full overflow-y-auto overflow-x-hidden p-4">
//       <div className="flex justify-between items-center mb-4">
//         <h2>Certificate Table</h2>
//         <Button appearance="primary" onClick={handleAddCertificate}>
//           Tambah Sertifikat
//         </Button>
//       </div>
//       <div className="mb-4">
//         <Input
//           placeholder="Search..."
//           value={searchKeyword}
//           onChange={handleSearch}
//         />
//       </div>
//       <Table
//         autoHeight
//         data={displayData}
//         onRowClick={(rowData) => {
//           console.log(rowData);
//         }}
//         rowHeight={100}
//       >
//         <Column width={60} align="center" fixed>
//           <HeaderCell>No</HeaderCell>
//           <Cell>
//             {(rowData, rowIndex) => {
//               const serialNumber = (page - 1) * limit + rowIndex + 1;
//               return <span>{serialNumber}</span>;
//             }}
//           </Cell>
//         </Column>

//         <Column width={100}>
//           <HeaderCell>Image</HeaderCell>
//           <Cell>
//             {(rowData) => (
//               <ImageModal
//                 imageUrl={
//                   isValidUrl(rowData.img) ? rowData.img : placeholderImage
//                 }
//               />
//             )}
//           </Cell>
//         </Column>

//         <Column width={200}>
//           <HeaderCell>Name</HeaderCell>
//           <Cell dataKey="name" className="py-2" />
//         </Column>

//         <Column width={200}>
//           <HeaderCell>Organizer</HeaderCell>
//           <Cell dataKey="organizer" className="py-2" />
//         </Column>

//         <Column width={150}>
//           <HeaderCell>Type</HeaderCell>
//           <Cell dataKey="type" className="py-2" />
//         </Column>

//         <Column width={150}>
//           <HeaderCell>Link</HeaderCell>
//           <Cell>
//             {(rowData) => (
//               <a href={rowData.link} target="_blank" rel="noopener noreferrer">
//                 {rowData.link}
//               </a>
//             )}
//           </Cell>
//         </Column>

//         <Column width={100}>
//           <HeaderCell>Status</HeaderCell>
//           <Cell>
//             {(rowData) => (
//               <Toggle
//                 checked={rowData.status === 1}
//                 size="sm"
//                 onChange={() => handleToggleStatus(rowData)}
//               />
//             )}
//           </Cell>
//         </Column>

//         <Column width={150}>
//           <HeaderCell>Action</HeaderCell>
//           <Cell>
//             {(rowData) => {
//               const handleDelete = () => {
//                 handleDeleteCertificate(rowData.id, data, setData);
//               };

//               const handleEdit = () => {
//                 handleUpdateCertificate(rowData);
//               };

//               return (
//                 <span>
//                   <a onClick={handleEdit}> Edit </a> |{" "}
//                   <a onClick={handleDelete}> Remove </a>
//                 </span>
//               );
//             }}
//           </Cell>
//         </Column>
//       </Table>
//       <div className="flex justify-end mt-4">
//         <Pagination
//           prev
//           next
//           first
//           last
//           ellipsis
//           boundaryLinks
//           maxButtons={5}
//           size="xs"
//           layout={["total", "-", "limit", "|", "pager"]}
//           total={data.length}
//           limitOptions={[5, 10, 20, 50]}
//           limit={limit}
//           activePage={page}
//           onChangePage={handleChangePage}
//           onChangeLimit={handleChangeLimit}
//         />
//       </div>

//       {/* Modal untuk tambah sertifikat */}
//       {isModalOpen && <ModalCertificate closeModal={closeModal} />}

//       {/* Modal untuk update sertifikat */}
//       {isUpdateModalOpen && selectedCertificate && (
//         <ModalUpdateCertificate
//           certificate={selectedCertificate}
//           onClose={closeModal}
//         />
//       )}
//     </div>
//   );
// };

// export default CertificateTable;


import React, { useState, useEffect, useMemo } from "react";
import { Table, Pagination, Input, Button, Toggle, InputGroup, Stack, Badge } from "rsuite";
import SearchIcon from '@rsuite/icons/Search';
import PlusIcon from '@rsuite/icons/Plus';
import EditIcon from '@rsuite/icons/Edit';
import TrashIcon from '@rsuite/icons/Trash';

import { fetchCertificates, updateCertificate, toggleCertificateFeatured } from "../../../api/certificateAPI";
import { placeholderImage, isValidUrl } from "../../invalidImage";
import ImageModal from "../../imageModal";
import ModalCertificate from "./addCertificate";
import ModalUpdateCertificate from "./updateCertificate";
import { handleDeleteCertificate } from "./deleteCertificateHandler";

const { Column, HeaderCell, Cell } = Table;

const CertificateTable = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const [selectedCertificate, setSelectedCertificate] = useState(null);

  const fetchData = async () => {
    setLoading(true);
    try {
      const certificatesData = await fetchCertificates();
      setData(certificatesData);
    } catch (err) {
      console.error("Error fetching data", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Memproses data (Filter + Pagination) dengan useMemo untuk performa
  const filteredData = useMemo(() => {
    return data.filter((item) =>
      item.name.toLowerCase().includes(searchKeyword.toLowerCase()) ||
      item.organizer.toLowerCase().includes(searchKeyword.toLowerCase())
    );
  }, [data, searchKeyword]);

  const displayData = useMemo(() => {
    const start = (page - 1) * limit;
    return filteredData.slice(start, start + limit);
  }, [filteredData, page, limit]);

  const handleToggleStatus = async (certificate) => {
    const updatedStatus = certificate.status === 1 ? 0 : 1;
    try {
      await updateCertificate(certificate.id, { ...certificate, status: updatedStatus });
      setData(prev => prev.map(item =>
        item.id === certificate.id ? { ...item, status: updatedStatus } : item
      ));
    } catch (error) {
      console.error("Failed to update status:", error);
    }
  };

  const handleToggleFeatured = async (certificate) => {
    try {
      const res = await toggleCertificateFeatured(certificate.id);
      setData(prev => prev.map(item =>
        item.id === certificate.id ? { ...item, is_featured: res.is_featured } : item
      ));
    } catch (error) {
      console.error("Failed to toggle featured:", error);
    }
  };

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      {/* Header Section */}
      <div className="bg-white p-6 rounded-t-xl border-b border-gray-100 shadow-sm">
        <Stack justifyContent="space-between" wrap gap={20}>
          <div>
            <h2 className="text-2xl font-bold text-gray-800">Certificate Management</h2>
            <p className="text-gray-500 text-sm">Manage and monitor all issued certificates.</p>
          </div>
          <Button 
            color="blue" 
            appearance="primary" 
            startIcon={<PlusIcon />} 
            onClick={() => setIsModalOpen(true)}
            className="shadow-md shadow-blue-200"
          >
            Add Certificate
          </Button>
        </Stack>

        <div className="mt-6 max-w-md">
          <InputGroup inside>
            <Input 
              placeholder="Cari nama sertifikat atau penyelenggara..." 
              value={searchKeyword}
              onChange={setSearchKeyword} 
            />
            <InputGroup.Addon>
              <SearchIcon />
            </InputGroup.Addon>
          </InputGroup>
        </div>
      </div>

      {/* Table Section */}
      <div className="bg-white shadow-sm rounded-b-xl overflow-hidden">
        <Table
          autoHeight
          data={displayData}
          loading={loading}
          hover={true}
          rowHeight={80}
          headerHeight={50}
        >
          <Column width={60} align="center" fixed>
            <HeaderCell className="font-bold text-gray-700">No</HeaderCell>
            <Cell>
              {(rowData, rowIndex) => (page - 1) * limit + rowIndex + 1}
            </Cell>
          </Column>

          <Column width={100} align="center">
            <HeaderCell className="font-bold text-gray-700">Gambar</HeaderCell>
            <Cell>
              {(rowData) => (
                <div className="flex justify-center items-center h-full">
                   <ImageModal
                    imageUrl={isValidUrl(rowData.img) ? rowData.img : placeholderImage}
                  />
                </div>
              )}
            </Cell>
          </Column>

          <Column flexGrow={1} minWidth={200}>
            <HeaderCell className="font-bold text-gray-700">Certificate Detail</HeaderCell>
            <Cell>
              {(rowData) => (
                <div>
                  <div className="font-semibold text-blue-600 uppercase text-xs tracking-wider">{rowData.type}</div>
                  <div className="text-gray-900 font-medium">{rowData.name}</div>
                  <div className="text-gray-500 text-xs">{rowData.organizer}</div>
                </div>
              )}
            </Cell>
          </Column>

          <Column width={150}>
            <HeaderCell className="font-bold text-gray-700">Status</HeaderCell>
            <Cell>
              {(rowData) => (
                <Stack spacing={10}>
                   <Toggle
                    checked={rowData.status === 1}
                    size="sm"
                    onChange={() => handleToggleStatus(rowData)}
                  />
                  <Badge color={rowData.status === 1 ? "green" : "red"} content={rowData.status === 1 ? "Active" : "Inactive"} />
                </Stack>
              )}
            </Cell>
          </Column>

          <Column width={100} align="center">
            <HeaderCell className="font-bold text-gray-700">Featured</HeaderCell>
            <Cell>
              {(rowData) => (
                <div className="flex justify-center items-center h-full">
                  <button
                    onClick={() => handleToggleFeatured(rowData)}
                    title="Toggle featured"
                    className={`w-8 h-8 rounded-lg flex items-center justify-center transition-all duration-200 ${
                      rowData.is_featured
                        ? "bg-yellow-100 text-yellow-600 hover:bg-yellow-200"
                        : "bg-gray-100 text-gray-400 hover:bg-gray-200"
                    }`}
                  >
                    <svg className="w-4 h-4" fill={rowData.is_featured ? "currentColor" : "none"} stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
                    </svg>
                  </button>
                </div>
              )}
            </Cell>
          </Column>

          <Column width={120} fixed="right">
            <HeaderCell className="font-bold text-gray-700">Aksi</HeaderCell>
            <Cell>
              {(rowData) => (
                <Stack spacing={10}>
                  <Button 
                    size="xs" 
                    color="blue" 
                    appearance="subtle" 
                    onClick={() => {
                      setSelectedCertificate(rowData);
                      setIsUpdateModalOpen(true);
                    }}
                  >
                    <EditIcon />
                  </Button>
                  <Button 
                    size="xs" 
                    color="red" 
                    appearance="subtle"
                    onClick={() => handleDeleteCertificate(rowData.id, data, setData)}
                  >
                    <TrashIcon />
                  </Button>
                </Stack>
              )}
            </Cell>
          </Column>
        </Table>

        {/* Pagination Section */}
        <div className="p-4 border-t border-gray-100 bg-gray-50">
          <Pagination
            prev
            next
            first
            last
            ellipsis
            boundaryLinks
            maxButtons={5}
            size="sm"
            layout={["total", "-", "limit", "|", "pager"]}
            total={filteredData.length}
            limitOptions={[5, 10, 20]}
            limit={limit}
            activePage={page}
            onChangePage={setPage}
            onChangeLimit={(val) => {
              setLimit(val);
              setPage(1);
            }}
          />
        </div>
      </div>

      {/* Modals */}
      {isModalOpen && <ModalCertificate closeModal={() => setIsModalOpen(false)} />}
      {isUpdateModalOpen && selectedCertificate && (
        <ModalUpdateCertificate
          certificate={selectedCertificate}
          onClose={() => setIsUpdateModalOpen(false)}
        />
      )}
    </div>
  );
};

export default CertificateTable;
